import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Grid,
  Typography,
} from "@mui/material";
import { FieldArray, FormikProps, useFormikContext } from "formik";
import React, { memo, useState } from "react";
import UpdateSection from "../../../../../common/updateSection/UpdateSection";
import { Data, Processor } from "../../../../../store/terminal/types";
import Confirm from "../../../../../common/confirm/Confirm";
import { Add, Delete, ExpandMore, Memory } from "@mui/icons-material";
import ProcessorForm from "./processorForm";
import pageStyles from "../../../../pageStyles";
interface EditProcessorProps {
  bulk: boolean;
  isUpdateAllowed?: boolean;
  shouldHideField: (fieldName: string) => boolean;
}
const createProcessor = {
  MID: "",
  PPID: "",
  ProcessorName: "",
  STAN: "",
  TID: "",
};

function EditProcessorComponent({ bulk, isUpdateAllowed, shouldHideField }: EditProcessorProps) {
  const [showConfirm, setShowConfirm] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(0);
  const styles = pageStyles();
  const formikProps = useFormikContext();
  const { values } = formikProps as FormikProps<Data>;
  return (
    <FieldArray
      name="attributes.Processor"
      render={(arrayHelpers) => {
        return (
          <>
            {values.attributes.Processor?.map((processor: Processor, index) => {
              return (
                <Accordion key={index} className={styles.Accordion}>
                  <AccordionSummary
                    expandIcon={<ExpandMore />}
                    aria-controls={`${index}_content`}
                    id={`${index}_header`}
                  >
                    <Box className={styles.processorTitleWrapper}>
                      <Typography className={styles.processorTitle}>
                        <Memory style={{ marginRight: "5px" }} />
                        {`Processor ${processor.ProcessorName}`}
                      </Typography>
                      <Button
                        color="secondary"
                        variant="outlined"
                        onClick={(): void => {
                          setDeleteItemId(index);
                          setShowConfirm(true);
                        }}
                        size="small"
                        startIcon={<Delete />}
                        disabled={!isUpdateAllowed}
                      >
                        Delete
                      </Button>
                    </Box>
                    <Confirm
                      isOpen={showConfirm}
                      onCancel={() => setShowConfirm(false)}
                      onConfirm={() => {
                        arrayHelpers.remove(deleteItemId);
                        setShowConfirm(false);
                      }}
                      title="Delete Processor"
                      icon="danger"
                      confirmLabel="Delete"
                      contentText={`You are about to delete a Processor`}
                    />
                  </AccordionSummary>
                  <AccordionDetails
                    style={{
                      background: "#fff",
                      borderTop: "1px solid #efefef",
                    }}
                  >
                    <Grid container style={{ marginTop: "15px" }}>
                      {bulk && !index && (
                        <Grid item xs={12}>
                          <UpdateSection name="sections.processor" />
                        </Grid>
                      )}
                      <Grid item xs={12}>
                        <ProcessorForm
                          isUpdateAllowed={isUpdateAllowed}
                          index={index}
                          processor={processor}
                        />
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              );
            })}
            <Grid item xs={12}>
              <Box textAlign="center">
                <Button
                  color="primary"
                  variant="contained"
                  size="medium"
                  endIcon={<Add />}
                  onClick={() => {
                    arrayHelpers.push(createProcessor);
                  }}
                  style={{ marginTop: "15px" }}
                  disabled={!isUpdateAllowed}
                >
                  Create Processor
                </Button>
              </Box>
            </Grid>
          </>
        );
      }}
    />
  );
}
export default memo(EditProcessorComponent);
